import React, { Component } from 'react'
import queryString from 'query-string'
import ReactPaginate from 'react-paginate';
import { TreeView, processTreeViewItems } from '@progress/kendo-react-treeview';
import Loading from './Loading'
import CategoryTree from './CategoryTree'
import { setGrayBody } from './BodyBg'
import TemplateBanben from '../../images/template_banben.png';

var docTypeList = [{ "id": 1, "name": "合同(两方)" },
{ "id": 2, "name": "合同(三方及以上)" },
{ "id": 4, "name": "律师文书" },
{ "id": 5, "name": "规章制度" },
{ "id": 7, "name": "证明|声明|授权" },
{ "id": 8, "name": "收据|借据|欠条" },
{ "id": 9, "name": "通知|申请|决定" },
{ "id": 12, "name": "办事流程|清单" },
{ "id": 15, "name": "行业模板(系列)" },
{ "id": 16, "name": "单项法律事务(系列)" },
{ "id": 14, "name": "其它类型" }];

export class Search extends Component {
    state = {
        key: [],
        category: [],
        category2: [],
        items: [],
        total: 0,
        totalPages: 0,
        showLoading: false,
        pageIndex: 0,
        pageSize: 10,
        categories: [],
        templateTypes: [],
        m: null,
        g: null,
        ccd: null,
        docType: [],
        docType2: [],
        newKey: "",
        newKey2: ""
    }

    componentDidMount() {
        setGrayBody();
        const parsed = queryString.parse(this.props.location.search);
        console.log(parsed)
        this.updateData({ key: [parsed.key], category: [parsed.category], category2: [{ Id: parsed.category, Name: parsed.categoryName }] });
    }

    handlePageClick = (e) => {
        console.log(e)
        this.updateData({ pageIndex: e.selected });
    }

    mClick = (e) => {
        var newValue = e.target.checked ? 1 : null;
        this.updateData({ m: newValue });
    }

    gClick = (e) => {
        var newValue = e.target.checked ? 1 : null;
        this.updateData({ g: newValue });
    }

    ccdClick = (e) => {
        var newValue = e.target.checked ? 1 : null;
        this.updateData({ ccd: newValue });
    }

    updateData(data) {
        this.setState(data, () => { this.loadData(); console.log(this.state) });
    }

    templateTypeClick = (e) => {
        var id = e.currentTarget.dataset.id;

        this.updateData({ docType: [id] });
    }

    searchChange = (e) => {
        console.log(e.currentTarget.value)
        this.setState({ newKey: e.currentTarget.value });
    }

    newSearchChange = (e) => {

        console.log(e.currentTarget.value)
        this.setState({ newKey2: e.currentTarget.value });

    }

    searchKeyDown = (e) => {
        if (e.target.value.replace(/^\s+|\s+$/g, "") != "" && e.keyCode === 13) {
            const value = e.target.value;
            const { key } = this.state;

            if (key.findIndex(x => x == value) == -1) {
                key.push(value)

                this.updateData({ key: key, newKey: "" })
            }
        }
    }

    newSearchKeyDown = (e) => {
        if (e.target.value.replace(/^\s+|\s+$/g, "") != "" && e.keyCode === 13) {
            const value = e.target.value;

            var key = [value]

            this.updateData({
                key: key,
                newKey2: "",
                category: [],
                category2: [],
                m: null,
                g: null,
                ccd: null,
                docType: [],
                docType2: []
            })
        }
    }

    addCategory = (id, name) => {
        const { category, category2 } = this.state;
        var repeat = false;
        for (var i = 0; i < category.length; i++) {
            if (id == category[i]) {
                repeat = true;
                return;
            }
        }
        if (!repeat) {
            var newCategory = category;
            var newCategory2 = category2;
            if (newCategory[0] == undefined) {
                newCategory = [];
                newCategory2 = [];
            }
            newCategory.push(id);
            newCategory2.push({ "Id": id, "Name": name });
            this.updateData({ category: newCategory, category2: newCategory2 })
        }
    }

    removeKey = (value) => {
        const { key } = this.state;
        for (var i = 0; i < key.length; i++) {
            if (value == key[i]) {
                key.splice(i, 1);
                this.updateData({ key: key })
            }
        }
    }

    addType = (id, name) => {
        const { docType, docType2 } = this.state;
        var repeat = false;
        for (var i = 0; i < docType.length; i++) {
            if (id == docType[i]) {
                repeat = true;
                return;
            }
        }
        if (!repeat) {
            docType.push(id);
            docType2.push({ "id": id, "name": name });
            this.updateData({ docType: docType, docType2: docType2 })
        }
    }

    removeType = (id) => {
        const { docType, docType2 } = this.state;
        for (var i = 0; i < docType.length; i++) {
            if (id == docType[i]) {
                docType.splice(i, 1);
            }
        }
        for (var i = 0; i < docType2.length; i++) {
            if (id == docType2[i].id) {
                docType2.splice(i, 1);
            }
        }
        this.updateData({ docType: docType, docType2: docType2 })
    }

    removeCategory = (id) => {
        const { category, category2 } = this.state;
        for (var i = 0; i < category.length; i++) {
            if (id == category[i]) {
                category.splice(i, 1);
            }
        }
        for (var i = 0; i < category2.length; i++) {
            if (id == category2[i].Id) {
                category2.splice(i, 1);
            }
        }
        this.updateData({ category: category, category2: category2 })
    }

    onItemClick = (event) => {
        console.log(event)
        this.addCategory(event.item.Id, event.item.Name);
    }
    onExpandChange = (event) => {
        event.item.expanded = !event.item.expanded;
        this.forceUpdate();
    }

    loadData = () => {
        const { key, category, pageIndex, m, g, ccd, docType } = this.state;

        const model = {
            Key: key,
            Category: category,
            p: pageIndex,
            m: m,
            g: g,
            ccd: ccd,
            doctype: docType
        };

        const stringified = queryString.stringify(model);

        this.setState({ showLoading: true })

        fetch('/api/template/search?' + stringified, {
            method: 'GET'
        }).then(Response => Response.json()).then(
            json => {
                console.log(json)
                var templateTypes = [];
                console.log(json.TemplateTypes)
                if (docTypeList) {
                    templateTypes = docTypeList.filter(p => json.TemplateTypes.findIndex(x => x == p.id) > -1);
                }

                var categories = this.createTreeData(json.Categories);

                this.setState({
                    items: json.Items,
                    total: json.Count,
                    totalPages: Math.ceil(json.Count / 10),
                    showLoading: false,
                    templateTypes: templateTypes,
                    categories: categories
                });
            }

        )
            .catch(error => {
                console.error(error);
                this.setState({ showLoading: false });
            })
    }

    createTreeData = (data) => {
        if (!data)
            return [];

        data.map(item => {
            item.items = item.Children
            if (item.HasChildren) {
                this.createTreeData(item.items);
            }
        });
        return data;
    }

    render() {
        return (
            <div>

                <div className="pt-4 clearfix templates-container">
                    <div className="clearfix w-box">
                        <div className="float-left templates-side">
                            <div>
                                <h2 className="font-green mt-0 mb-4">筛选</h2>
                            </div>
                            <div className="mt-2">

                                <div>
                                    <input className="template-search-input w-100" type="text" placeholder="在结果中继续搜索" value={this.state.newKey} onChange={this.searchChange} onKeyDown={this.searchKeyDown} />
                                </div>

                                {
                                    (this.state.key.length > 0 && this.state.key[0] != undefined) && (
                                        <div className="mt-3 template-side-filter">
                                            <div><b>关键词</b></div>
                                            <ul className="mt-1">
                                                {
                                                    this.state.key.map(item => (
                                                        <li className="clearfix" key={`key${item}`}>
                                                            <span>{item}</span>
                                                            {
                                                                (this.state.key.length > 1 || (this.state.category.length != 0 && this.state.category[0] != undefined)) && (
                                                                    <a className="float-right" onClick={this.removeKey.bind(this, item)}></a>
                                                                )
                                                            }
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    )
                                }

                                {
                                    (this.state.category2.length > 0 && this.state.category[0] != undefined) && (
                                        <div className="mt-3 template-side-filter">
                                            <div><b>合同分类</b></div>
                                            <ul>
                                                {
                                                    this.state.category2.map(item => (
                                                        <li className="clearfix" key={item.Id}>
                                                            <span>{item.Name}</span>
                                                            {
                                                                (this.state.category2.length > 1 || (this.state.key.length != 0 && this.state.key[0] != undefined)) && (
                                                                    <a className="float-right" onClick={this.removeCategory.bind(this, item.Id)}></a>
                                                                )
                                                            }
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    )
                                }

                                {
                                    this.state.docType2.length > 0 && (
                                        <div className="mt-3 template-side-filter">
                                            <div><b>文档类型</b></div>
                                            <ul>
                                                {
                                                    this.state.docType2.map(item => (
                                                        <li className="clearfix" key={item.id}>
                                                            <span>{item.name}</span><a className="float-right" onClick={this.removeType.bind(this, item.id)}></a>
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    )
                                }

                            </div>

                            <div className="mt-4">

                                <div>
                                    <h5><span>合同分类</span><span></span></h5>
                                    <TreeView
                                        data={this.state.categories}
                                        textField="Name"
                                        itemsField="Children"
                                        hasChildrenField="HasChildren"
                                        onExpandChange={this.onExpandChange}
                                        onItemClick={this.onItemClick}
                                        aria-multiselectable={false}
                                    />
                                </div>

                                <div className="mt-3">
                                    <h5>文档类型</h5>
                                    <div>
                                        {
                                            this.state.templateTypes.map(item => (
                                                <div className="mt-2" key={item.id}>
                                                    <a onClick={this.addType.bind(this, item.id, item.name)}>{item.name}</a>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>

                                <div className="mt-3">
                                    <h5>文本标签</h5>
                                    <div className="templates-tags">
                                        <div>
                                            <input type="checkbox" id="m" onChange={this.mClick} checked={this.state.m == 1 ? true : false} /><label htmlFor="m"><span>系列模板</span></label>
                                        </div>
                                        <div>
                                            <input type="checkbox" id="g" onChange={this.gClick} checked={this.state.g == 1 ? true : false} /> <label htmlFor="g"><span>政府示范</span></label>
                                        </div>
                                        <div>
                                            <input type="checkbox" id="ccd" onChange={this.ccdClick} checked={this.state.ccd == 1 ? true : false} /><label htmlFor="ccd"><span>已出版</span></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="float-left templates-result pl-4 pr-4 fts-bg-gray">
                            <div className="fts-bg-white">
                                <div className="p-2 pl-5">
                                    <input className="template-search-input w-100 bg-white" type="text" placeholder="重新搜索文本" value={this.state.newKey2} onChange={this.newSearchChange} onKeyDown={this.newSearchKeyDown} />
                                </div>
                                <div className="fts-bg-gray w-100"></div>

                                <div className="p-4">
                                    <div className="templates-result-list">

                                        {
                                            this.state.items.map(
                                                item => (
                                                    <div className="templates-result-item" key={item.Id}>

                                                        <div className="templates-result-icon">
                                                            <div></div>
                                                        </div>

                                                        <div>

                                                            <div className="templates-result-title clearfix mb-3">
                                                                <div className="float-left">
                                                                    {
                                                                        item.Rank > 0 && (
                                                                            <div className="search-rank">推荐</div>
                                                                        )
                                                                    }
                                                                    <a target="_blank" rel="noopener noreferrer" href={item.IsMultiple ? "F" + item.Number : "D" + item.Number}>
                                                                        <span className="bold font-m font-green mr-1">#{item.Number}</span>
                                                                        <span className="mr-2">{item.Title}</span>
                                                                        {
                                                                            item.Title2 != null && (
                                                                                <span className="font-m mr-2">{item.Title2}</span>
                                                                            )
                                                                        }
                                                                        {
                                                                            (item.VersionTag.length > 0 || item.ContentTag.length > 0) && (
                                                                                <span className="templates-versiontag font-m">
                                                                                    <img className="mr-1" src={TemplateBanben} />
                                                                                    {item.VersionTag.map(name => (
                                                                                        <span className="mr-1" key={name}>
                                                                                            {name}
                                                                                        </span>
                                                                                    ))}
                                                                                    {item.ContentTag.map(name => (
                                                                                        <span className="mr-1" key={name}>
                                                                                            {name}
                                                                                        </span>
                                                                                    ))}
                                                                                </span>
                                                                            )
                                                                        }
                                                                    </a>
                                                                </div>

                                                            </div>
                                                            {
                                                                item.AuthorId != null && (
                                                                    <div className="templates-result-avatar">
                                                                        <img className="img-circle" src={item.AuthorAvatar} />
                                                                        <span className="ml-1">{item.AuthorName}</span>
                                                                    </div>
                                                                )
                                                            }

                                                            <div className="templates-result-other-tags mb-2">
                                                                {
                                                                    (item.SceneFor.length > 0 || item.SceneNotFor.length > 0) && (
                                                                        <span>
                                                                            {
                                                                                item.SceneFor.length > 0 && (
                                                                                    <span className="font-green">适用于：</span>
                                                                                )
                                                                            }
                                                                            {item.SceneFor.map(name => (
                                                                                <span className="font-green" key={name}>
                                                                                    {name}
                                                                                </span>
                                                                            ))}
                                                                            {
                                                                                item.SceneNotFor.length > 0 && (
                                                                                    <span className="font-yellow">不适用于：</span>
                                                                                )
                                                                            }
                                                                            {item.SceneNotFor.map(name => (
                                                                                <span className="font-yellow" key={name}>
                                                                                    {name}
                                                                                </span>
                                                                            ))}
                                                                        </span>
                                                                    )
                                                                }
                                                            </div>

                                                            <div dangerouslySetInnerHTML={{ __html: item.Brief }}></div>

                                                            <div className="templates-result-info clearfix">
                                                                <div className="float-left templates-result-tags">
                                                                    {
                                                                        item.Price > 0 ? (
                                                                            <div className="d-inline-block price text-left bold">{item.Price.toFixed(2)} 元</div>
                                                                        ) : (
                                                                            <div className="d-inline-block price text-left bold">免费</div>
                                                                        )
                                                                    }

                                                                    {
                                                                        item.IsGovernment && (
                                                                            <div className="government">政府示范</div>
                                                                        )
                                                                    }
                                                                    {
                                                                        item.IsCCD && (
                                                                            <div className="ccd">已出版</div>
                                                                        )
                                                                    }
                                                                    {
                                                                        item.IsMultiple && (
                                                                            <div className="multiple">系列</div>
                                                                        )
                                                                    }

                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                )
                                            )
                                        }

                                    </div>

                                    <div className="text-center">
                                        <ReactPaginate
                                            previousLabel={'前一页'}
                                            nextLabel={'下一页'}
                                            breakLabel={'...'}
                                            breakClassName={'break-me'}
                                            pageCount={this.state.totalPages}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={5}
                                            onPageChange={this.handlePageClick}
                                            containerClassName={'pagination'}
                                            subContainerClassName={'pages pagination'}
                                            activeClassName={'active'}
                                        />
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <Loading isLoading={this.state.showLoading} />
            </div>

        )
    }
}

export default Search